import { FILE_EXTENSION_REGEX } from 'constants/files';

const getFileType = (file: File) => {
  const extensionFromFileType = file.type.split('/').pop();
  const extension =
    FILE_EXTENSION_REGEX.exec(file.name)[1] || extensionFromFileType;

  return extension.toLowerCase();
};

export { getFileType };
